import { ENDPOINT_URLS } from '~/global/toggle-api';
import { APIFetch } from '~/shared/services/api-fetch';
import { ScenarioResponse } from '~/views/analyze/experiment/components/condition-builder/utils/conditionHelpers';

export const fetchScenarioConditions = async (id?: string) => {
  return APIFetch<ScenarioResponse>(
    `${ENDPOINT_URLS.EXPERIMENT_SCENARIO_BY_ID}/${id}`
  );
};
